import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError, BaseResponse } from '@utils/types/shared/base';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params';

export interface CustomerBoUsage {
  period_start: string;
  period_end: string;
  stt_units_used: number;
  alignment_units_used: number;
  translation_characters_used: number;
  custom_models_trained: number;
  custom_models_hosted: number;
  cost_billed: number;
  billed: boolean;
}

export type CustomerBoUsageResponse = BaseResponse<CustomerBoUsage[]>;

export const useGetCustomerBoUsage = (
  customerId: number,
  subscriptionId: number
) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchUsage = async () => {
    const { customerBoUsagesByCustomerAndSubscriptionId } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });

    const url = customerBoUsagesByCustomerAndSubscriptionId(
      customerId,
      subscriptionId
    );
    const { data } = await Axios.get<CustomerBoUsageResponse>(url);
    return data;
  };

  return useQuery<CustomerBoUsageResponse, AxiosError<BaseError>>(
    [
      'customerBoUsage',
      customerId,
      subscriptionId,
      offset,
      limit,
      qString,
      sortField,
      sortDirection
    ],
    fetchUsage,
    {
      enabled:
        Number.isFinite(customerId) &&
        customerId > 0 &&
        Number.isFinite(subscriptionId) &&
        subscriptionId > 0,
      keepPreviousData: true,
      useErrorBoundary: false
    }
  );
};
